import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DashboardState {
  banners: any[];
  introSliders: any[];
  categories: any[];
  newPlaces: any[];
  curatedPlaces: any[];
  tripsItinerary: any[];
}

const initialState: DashboardState = {
  banners: [],
  introSliders: [],
  categories: [],
  newPlaces: [],
  curatedPlaces: [],
  tripsItinerary: [],
};

const DashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // Replace entire dashboard payload in one go
    setDashboard: (state, action: PayloadAction<DashboardState>) => {
      return { ...state, ...action.payload };
    },
    // Individual setters in case only one section needs updating
    setBanners: (state, action: PayloadAction<any[]>) => {
      state.banners = action.payload;
    },
    setIntroSliders: (state, action: PayloadAction<any[]>) => {
      state.introSliders = action.payload;
    },
    setDashboardCategories: (state, action: PayloadAction<any[]>) => {
      state.categories = action.payload;
    },
    setNewPlaces: (state, action: PayloadAction<any[]>) => {
      state.newPlaces = action.payload;
    },
    setCuratedPlaces: (state, action: PayloadAction<any[]>) => {
      state.curatedPlaces = action.payload;
    },
    setTrips: (state, action: PayloadAction<any[]>) => {
      state.tripsItinerary = action.payload;
    },
  },
});

export const {
  setDashboard,
  setBanners,
  setIntroSliders,
  setDashboardCategories,
  setNewPlaces,
  setCuratedPlaces,
  setTrips,
} = DashboardSlice.actions;

export default DashboardSlice.reducer; 